import { Box, Tab, Tabs, Typography } from "@mui/material";
import React from "react";
import OtSheetDetails from "./OtSheetDetails";
import SurgeryDetails from "./SurgeryDetails";
import DoctorEmpDetails from "./DoctorEmpDetails";
import Instruments from "./Instruments";
import SurgeryNotes from "./SurgeryNotes";
import AnesthetiaNotes from "./AnesthetiaNotes";
import PendingImplants from "./PendingImplants";
import PropTypes from "prop-types";
import { useContext } from "react";
import { OtDetailsContext } from "./OtDetails";
import UploadFileDetails from "./UploadFileDetails";
import ShiftingNotesModel from "./ShiftingNotesModel";
import IntraOperativeNotesModel from "./IntraOperativeNotesModel";
import PreOperativeNotesModel from "./PreOperativeNotesModel";
import PostOperativeNotesModel from "./PostOperativeNotesModel";
import { getIntraOperativeNotes, getpostOperativeNotes, getpreOperativeNotes, getShiftingNotes } from "../../../services/otDetailsServices/OtDetailsServices";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const OtDetailsTabs = () => {
  const { tabValue, setTabValue, isDisable, admissionId, otHeaderId, } = useContext(OtDetailsContext);
  const [shiftingNotesData, setShiftingNotesData] = React.useState(null);
  const [intraOperativeData, setIntraOperativeData] = React.useState(null);
  const [postOperativeNotes, setpostOperativeNotes] = React.useState(null);
  const [preOperativeNotes, setpreOperativeNotes] = React.useState(null);
  //

  React.useEffect(() => {
    if (tabValue === 8) {
      handleShiftingNotesOpen();
    }
    if (tabValue === 9) {
      handlePreOperativeNotesOpen()


    }
    if (tabValue === 10) {
      handleIntraOperativeNotesOpen()

    }
    if (tabValue === 11) {
      handlePostOperativeNotesOpen()

    }

  }, [tabValue]);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };


  const handleShiftingNotesOpen = async () => {
    try {

      const response = await getShiftingNotes(
        admissionId,
        otHeaderId
      );

      if (response?.data?.result?.id) {
        setShiftingNotesData(response.data.result);
      } else {
        setShiftingNotesData(null);
      }

      // setOpenShiftingNotes(true);

    } catch (error) {
      console.log(error);

      setShiftingNotesData(null);

      // setOpenShiftingNotes(true);
    }
  };








  const handleIntraOperativeNotesOpen = async () => {
    try {
      console.log("kdlsdkjfsjdfsffs", admissionId, otHeaderId);

      const response = await getIntraOperativeNotes(
        admissionId,
        otHeaderId
      );

      if (response?.data?.result?.id) {
        setIntraOperativeData(response.data.result);
      } else {
        setIntraOperativeData(null);
      }

      // setOpenIntraOperativeNotes(true);

    } catch (error) {
      console.log(error);

      setIntraOperativeData(null);
      // setOpenIntraOperativeNotes(true);
    }
  };


  const handlePostOperativeNotesOpen = async () => {
    try {


      const response = await getpostOperativeNotes(
        admissionId,
        otHeaderId
      );

      if (response?.data?.result) {
        setpostOperativeNotes(response.data.result);
      } else {
        setpostOperativeNotes(null);
      }

      // setOpenPostOperativeNotes(true);

    } catch (error) {
      console.log(error);

      setpostOperativeNotes(null);

      // setOpenPostOperativeNotes(true);
    }
  };



  const handlePreOperativeNotesOpen = async () => {
    try {

      const response = await getpreOperativeNotes(
        admissionId,
        otHeaderId
      );

      if (response?.data?.result?.id) {
        setpreOperativeNotes(response.data.result);
      } else {
        setpreOperativeNotes(null);
      }

      // setOpenPreOperativeNotes(true);

    } catch (error) {
      console.log(error);

      setpreOperativeNotes(null);
      // setOpenPreOperativeNotes(true);
    }
  };


















  return (
    <div>
      <div className="col-span-12">
        <Box
          sx={{
            width: "100%",
          }}
        >
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              backgroundColor: "#dfe6e9",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              aria-label="basic tabs example"
              variant="scrollable"
              scrollButtons
            >
              <Tab label="OT Sheet Details" {...a11yProps(0)} />
              <Tab
                label="Surgery Details"
                disabled={isDisable}
                {...a11yProps(1)}
              />
              <Tab label="Doctor/Emp" disabled={isDisable} {...a11yProps(2)} />
              <Tab
                label="Instruments "
                disabled={isDisable}
                {...a11yProps(3)}
              />
              <Tab
                label="Surgery Notes"
                disabled={isDisable}
                {...a11yProps(4)}
              />
              <Tab
                label="Anesthesia Notes "
                disabled={isDisable}
                {...a11yProps(5)}
              />
              <Tab
                label="File Upload "
                disabled={isDisable}
                {...a11yProps(6)}
              />
              <Tab
                label="Pending Implants "
                disabled={isDisable}
                {...a11yProps(7)}
              />
              <Tab label="Patient Shifting" disabled={isDisable} {...a11yProps(8)} />
              <Tab label="Pre-Operative Notes" disabled={isDisable} {...a11yProps(9)} />
              <Tab label="Intra-Operatvie Notes" disabled={isDisable} {...a11yProps(10)} />
              <Tab label="Post-Operatvie Notes" disabled={isDisable} {...a11yProps(11)} />
            </Tabs>
          </Box>

          <TabPanel value={tabValue} index={0}>
            <OtSheetDetails />
          </TabPanel>

          <TabPanel value={tabValue} index={1}>
            <SurgeryDetails />
          </TabPanel>

          <TabPanel value={tabValue} index={2}>
            <DoctorEmpDetails />
          </TabPanel>

          <TabPanel value={tabValue} index={3}>
            {/* <Documents /> */}
            <Instruments />
          </TabPanel>

          <TabPanel value={tabValue} index={4}>
            {/* <Documents /> */}
            <SurgeryNotes />
          </TabPanel>

          <TabPanel value={tabValue} index={5}>
            {/* ansthesia */}
            <AnesthetiaNotes />
          </TabPanel>

          <TabPanel value={tabValue} index={6}>
            {/* <Documents /> */}
            <UploadFileDetails />
          </TabPanel>

          <TabPanel value={tabValue} index={7}>
            <PendingImplants />
          </TabPanel>
          <TabPanel value={tabValue} index={8}>
            <ShiftingNotesModel patientData={shiftingNotesData} admissionId={admissionId} otHeaderId={otHeaderId} />
          </TabPanel>
          <TabPanel value={tabValue} index={9}><PreOperativeNotesModel patientData={preOperativeNotes} admissionId={admissionId} otHeaderId={otHeaderId} /></TabPanel>
          <TabPanel value={tabValue} index={10}><IntraOperativeNotesModel patientData={intraOperativeData} admissionId={admissionId} otHeaderId={otHeaderId} /></TabPanel>
          <TabPanel value={tabValue} index={11}><PostOperativeNotesModel patientData={postOperativeNotes} admissionId={admissionId} otHeaderId={otHeaderId} /></TabPanel>
        </Box>
      </div>
    </div>
  );
};

export default OtDetailsTabs;
